import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";

const MOBILE_REDIRECTED_KEY = "mobile_lang_redirected";

function MobileRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth < 768;

    const alreadyRedirected = sessionStorage.getItem(MOBILE_REDIRECTED_KEY);

    if (isMobile && !alreadyRedirected && location.pathname === "/") {
      sessionStorage.setItem(MOBILE_REDIRECTED_KEY, "true");
      navigate("/en", { replace: true });
    }
  }, [navigate, location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <MobileRedirect />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
